import React, { useEffect } from 'react';
import single from '../assets/popup/Check.png';
import danger from '../assets/popup/Danger.png';

const ApiResponseBox = ({ show, onClose, errorMessage, poptype = "Error",time=1100 }) => {
  const imageToShow = poptype === "Error" ? danger : single;

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);


  useEffect(()=>{
    if(show && poptype !== "Error"){
      setTimeout(() => {
        onClose();
      }, time);
    }
  },[show])

  if (!show) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <button className="popup-close" onClick={onClose}>×</button>
        <div className="blue-half-circle">
          <img src={imageToShow} alt="Popup Icon" className="popup-image" />
        </div>
        <div className="popup-content">
          <h4 style={{ color: '#823455' }}>{poptype}</h4>
          <p>{errorMessage}</p>
        </div>
      </div>
    </div>
  );
};

export default ApiResponseBox;
